import React, { type CSSProperties } from "react";

import clsx from "clsx";

import { type CategoricalBreakdownConfig } from "@north-beam/nb-common";

interface Props {
  className?: string;
  style?: CSSProperties;
  row: CategoricalBreakdownConfig;
  onClick(): void;
}

export const Option = ({ className, style, row, onClick }: Props) => (
  <div
    style={style}
    className={clsx(
      "w-full text-left px-4 hover:bg-cosmic-4 h-8 flex items-center cursor-pointer",
      "absolute top-0 left-0",
      className,
    )}
    onClick={onClick}
  >
    <span className="truncate">{row.name}</span>
  </div>
);
